(function(){
  'use strict';
  function ready(fn){if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',fn,{once:true});}else{fn();}}
  ready(function(){
    var modal=document.getElementById('psScratchModal');
    if(!modal||window.Shopify&&Shopify.designMode)return;

    var key=modal.getAttribute('data-storage-key');
    try{if(localStorage.getItem(key))return;}catch(e){}

    var random=new Uint32Array(1);
    if(window.crypto&&crypto.getRandomValues){crypto.getRandomValues(random);}else{random[0]=Math.floor(Math.random()*4294967296);}
    var won=(random[0]%10)===0;
    try{localStorage.setItem(key,JSON.stringify({shown:true,won:won,at:Date.now()}));}catch(e){}

    var win=modal.querySelector('[data-scratch-win]');
    var lose=modal.querySelector('[data-scratch-lose]');
    (won?win:lose).hidden=false;
    modal.hidden=false;
    document.body.classList.add('ps-scratch-open');

    modal.querySelectorAll('[data-scratch-close]').forEach(function(el){
      el.addEventListener('click',function(){modal.hidden=true;document.body.classList.remove('ps-scratch-open');});
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'&&!modal.hidden){modal.hidden=true;document.body.classList.remove('ps-scratch-open');}
    });

    var canvas=document.getElementById('psScratchCanvas');
    var card=document.getElementById('psScratchCard');
    var ctx=canvas.getContext('2d',{willReadFrequently:true});
    var drawing=false,moves=0,revealed=false;

    function paint(){
      var rect=card.getBoundingClientRect();
      var dpr=Math.min(window.devicePixelRatio||1,2);
      canvas.width=Math.round(rect.width*dpr);
      canvas.height=Math.round(rect.height*dpr);
      ctx.setTransform(dpr,0,0,dpr,0,0);
      var gradient=ctx.createLinearGradient(0,0,rect.width,rect.height);
      gradient.addColorStop(0,'#f7dc82');
      gradient.addColorStop(.45,'#b88927');
      gradient.addColorStop(1,'#f3cf66');
      ctx.globalCompositeOperation='source-over';
      ctx.fillStyle=gradient;
      ctx.fillRect(0,0,rect.width,rect.height);
      ctx.fillStyle='rgba(255,255,255,.72)';
      ctx.textAlign='center';
      ctx.textBaseline='middle';
      ctx.font='900 31px Arial, sans-serif';
      ctx.fillText('SKRAPA HÄR',rect.width/2,rect.height/2);
      ctx.globalCompositeOperation='destination-out';
      ctx.lineCap='round';
      ctx.lineJoin='round';
      ctx.lineWidth=46;
    }
    paint();

    function point(e){
      var rect=canvas.getBoundingClientRect();
      return{x:e.clientX-rect.left,y:e.clientY-rect.top};
    }
    function reveal(){
      if(revealed)return;
      revealed=true;
      canvas.style.opacity='0';
      canvas.style.pointerEvents='none';
      setTimeout(function(){canvas.hidden=true;},360);
    }
    function check(){
      var data=ctx.getImageData(0,0,canvas.width,canvas.height).data;
      var transparent=0,total=0,step=48;
      for(var i=3;i<data.length;i+=step){total++;if(data[i]<50)transparent++;}
      if(transparent/total>.38)reveal();
    }
    canvas.addEventListener('pointerdown',function(e){drawing=true;canvas.setPointerCapture(e.pointerId);var p=point(e);ctx.beginPath();ctx.moveTo(p.x,p.y);});
    canvas.addEventListener('pointermove',function(e){if(!drawing||revealed)return;var p=point(e);ctx.lineTo(p.x,p.y);ctx.stroke();moves++;if(moves%8===0)check();});
    function stop(){if(drawing){drawing=false;check();}}
    canvas.addEventListener('pointerup',stop);
    canvas.addEventListener('pointercancel',stop);

    var size=document.getElementById('psScratchSize');
    var claim=document.getElementById('psScratchClaim');
    var error=document.getElementById('psScratchError');
    if(size&&claim){
      size.addEventListener('change',function(){claim.disabled=!size.value;});
      claim.addEventListener('click',function(){
        if(!size.value)return;
        claim.disabled=true;
        claim.textContent='Lägger till…';
        error.textContent='';
        fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:Number(size.value),quantity:1,properties:{Kampanj:'Skrapvinst'}}]})
        }).then(function(response){
          if(!response.ok)throw new Error('cart');
          return response.json();
        }).then(function(){
          var code=encodeURIComponent(modal.getAttribute('data-discount'));
          window.location.href='/discount/'+code+'?redirect=/collections/strumpor';
        }).catch(function(){
          error.textContent='Något gick fel. Försök igen.';
          claim.disabled=false;
          claim.textContent='Lägg till vinsten och välj köppar';
        });
      });
    }
  });
})();